import * as types from "../actions/actionTypes";
import { getAllOrderDispatchsResponse, getOrderDispatchByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const orderdispatchEntity = createEntitySagas({
  entity: "orderdispatch",
  endpoint: "order-dispatches",
  label: "Dispatch",
  scope: "none",
  selectSlice: (state) => state.orderdispatch,
  listKey: "dispatches",
  types: {
    getAll: types.GET_ALL_ORDER_DISPATCHS,
    getById: types.GET_ORDER_DISPATCH_BY_ID,
    create: types.CREATE_ORDER_DISPATCH,
    update: types.UPDATE_ORDER_DISPATCH,
    remove: types.DELETE_ORDER_DISPATCH,
  },
  actions: { getAllResponse: getAllOrderDispatchsResponse, getByIdResponse: getOrderDispatchByIdResponse },
});

export const orderdispatchSaga = orderdispatchEntity.watcher;
